import { ShieldAlert } from "lucide-react";
import classnames from "classnames";

import BrandsPanel from "./components/brands-panel";
import HoldersPanel from "./components/holders-panel";
import InvoicesPanel from "./components/invoices-panel";
import OpsAccountPanel from "./components/ops-account-panel";
import themeConfig from "@configs/theme-config";
import useSuperadmin from "./hooks/use-superadmin";
import { SUPERADMIN_TABS, TAB } from "./misc/constants";

// ─── TEMPORARY ────────────────────────────────────────────────────────────────
// An internal bootstrap console for the onboarding APIs, a tab per step of the
// flow: create an ops account, create a brand, create that brand's admin and
// publisher logins, then raise an invoice for one of its publishers. Each tab
// is one endpoint and nothing more (the invoice tab reads the publisher list to
// raise against). It sits outside src/views/panel — no role workspace, no
// CASL subject — so it can be deleted in one move. See the removal note in
// src/router/routes/superadmin.jsx.
const Superadmin = () => {
    const { activeTab, setActiveTab } = useSuperadmin();

    return (
        <div className="min-h-screen bg-light/50 p-6">
            <div className="mx-auto max-w-[1400px]">
                <div className="flex flex-wrap items-start justify-between gap-3">
                    <div>
                        <div className="flex items-center gap-2">
                            <ShieldAlert className="h-5 w-5 text-held" />
                            <h1 className="text-2xl font-semibold tracking-tight">Superadmin</h1>
                        </div>
                        <p className="mt-1 text-sm text-muted">
                            Internal onboarding console — ops account, then brand, then its logins, then invoices.
                        </p>
                    </div>
                    <code className="rounded-lg border border-gray-200 bg-white px-3 py-2 text-xs text-muted">
                        {themeConfig.apiUrl.base}
                    </code>
                </div>

                <div className="mt-6 flex flex-wrap items-center gap-1 border-b border-gray-200">
                    {SUPERADMIN_TABS.map((tab) => (
                        <button
                            key={tab.key}
                            type="button"
                            onClick={() => setActiveTab(tab.key)}
                            className={classnames(
                                "-mb-px border-b-2 px-4 py-2.5 text-sm font-medium transition-colors",
                                activeTab === tab.key
                                    ? "border-primary text-primary"
                                    : "border-transparent text-muted hover:text-gray-700"
                            )}>
                            {tab.label}
                        </button>
                    ))}
                </div>

                <div className="mt-6">
                    {activeTab === TAB.OPS && <OpsAccountPanel />}
                    {activeTab === TAB.BRANDS && <BrandsPanel />}
                    {activeTab === TAB.HOLDERS && <HoldersPanel />}
                    {activeTab === TAB.INVOICES && <InvoicesPanel />}
                </div>
            </div>
        </div>
    );
};

export default Superadmin;
